import Breadcrumb, { BreadcrumbItem } from 'components/breadcrumb'
import LongText from 'components/long-text'

const Header = ({
  title,
  description,
  breadcrumbItems,
}: {
  title: string
  description?: string
  breadcrumbItems?: BreadcrumbItem[]
}): JSX.Element => {
  return (
    <header className="p-4">
      <div className="hidden lg:block">
        {breadcrumbItems && (
          <Breadcrumb
            className="mb-2 text-sm font-medium"
            items={breadcrumbItems}
          />
        )}
      </div>
      <h1 className="text-2xl font-bold">{title}</h1>
      {description && (
        <LongText className="mt-1 text-gray-400 text-xs" text={description} />
      )}
    </header>
  )
}

export default Header
